import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { accentColors, secondaryColors } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

interface ContainerProps {
  $isRedesign?: boolean;
  $isDimmed?: boolean;
}

export const StyledBadgeItemContainer = styled.article<ContainerProps>`
  display: flex;
  margin-bottom: 4.6rem;
  gap: 1rem;
  opacity: ${({ $isDimmed }) => ($isDimmed ? 0.5 : 1)};
`;

export const StyledBadgeImageContainer = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  min-width: 12.8rem;
  max-width: 12.8rem;
  height: 15rem;
  position: ${({ $isRedesign }) => ($isRedesign ? 'relative' : 'unset')};
  img {
    max-width: inherit;
  }
`;

export const StyledBadgeTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  width: 16.8rem;
  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) and (max-width: ${({ theme }) => theme.sizes.lg}) {
    width: 19.6rem;
  }
`;

export const StyledBadgeTitleContainer = styled.div`
  margin-bottom: 0.6rem;
`;

export const StyledBadgeTitle = styled.p`
  font-size: 1.8rem;
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  color: ${({ theme }) => theme.colors.paragraph};
  line-height: 2.263rem;
  margin-bottom: 0.6rem;
`;

export const StyledBadgeDescription = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 2.011rem;
  color: ${({ theme }) => theme.colors.paragraph};
`;

export const StyledTickIcon = styled(FontAwesomeIcon)<{ $isDark?: boolean }>`
  position: absolute;
  bottom: 0;
  right: 0;
  font-size: 3.4rem;
  background-color: ${({ $isDark }) => ($isDark ? accentColors.success.dark : accentColors.success.light)};
  border-radius: 50%;

  path {
    fill: ${({ $isDark }) => ($isDark ? secondaryColors.black : secondaryColors.grey[100])};
  }
`;
